import React from 'react';
import { FontAwesomeIconWrapper } from "/react4xp/components/FontAwesomeIconWrapper";
import { faBellSlash, faClockRotateLeft } from "@fortawesome/pro-light-svg-icons";

export const NoActiveAlerts = ({ isActive }: { isActive: boolean }): React.JSX.Element => {
	const title = isActive ? "Ingen aktive varsler for øyeblikket" : "Ingen tidligere varsler enda";
	const subtitle = isActive ? 'Aktive varsler om farlige stoffer vil vises her, men for øyeblikket er det ingen.' : 'Historikk over tidligere varsler vil vises her, men for øyeblikket er det ingen.';
	const icon = isActive ? faBellSlash : faClockRotateLeft;

	return (
		<div className="flex flex-col items-center align-middle gap-xl mx-auto max-w-[320px]">
			<FontAwesomeIconWrapper
				className='text-darkgray'
				icon={icon}
				fixedWidth={true}
				size={'4x'}
			/>
			<div className="flex flex-col gap-sm text-darkgray">
				<h2 className="text-center text-xl font-bold">{title}</h2>
				<p className="text-center">{subtitle}</p>
			</div>
		</div>
	);
};
